<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de sustancias no peligrosas</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Nombre">
                    <b-form-input v-model="filterSubNotDangerSga.search" type="text" placeholder="Buscar por nombre"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchSubNotDanger">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <el-tooltip effect="light" placement="top" popper-class="py-1 px-2" content="Sincronizar idiomas">
                        <b-button variant="warning" class="ml-1 mr-1" @click="asyncLanguagesSubNotDangerSga">
                            <i class="fa fa-language" aria-hidden="true"></i>
                        </b-button>
                    </el-tooltip>
                    <b-button variant="primary" @click="createSubNotDanger">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nueva sustancia no peligrosa'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                <b-table
                    :items="subNotDangerSga"
                    :fields="fields"
                    :busy="$store.state.dashboard.loading"
                    responsive
                    striped
                    hover
                    bordered
                    thead-tr-class="table-active"
                    thead-class="table-active"
                    show-empty
                    empty-text="No hay sustancias no peligrosas para mostrar"
                    class="mt-3"
                >
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Cargando...</strong>
                        </div>
                    </template>

                    <template #cell(name)="data">
                        <strong>{{ data.item.name }}</strong>
                    </template>
                    <template #cell(is_active)="data">
                        <b-badge :variant="data.item.is_active ? 'success' : 'danger'"
                            v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
                    </template>

                    <template #cell(languages)="data">
                        <div v-if="data.item.sub_not_danger_languages && data.item.sub_not_danger_languages.length > 0">
                            <b-badge 
                                v-for="lang in data.item.sub_not_danger_languages" 
                                :key="lang.id"
                                variant="info" 
                                class="mr-1 mb-1"
                            >
                                {{ lang.language ? lang.language.code : (lang.sga_language ? lang.sga_language.code : 'N/A') }}
                            </b-badge>
                        </div>
                        <span v-else class="text-muted">Sin idiomas</span>
                    </template>

                    <template #cell(actions)="data">
                        <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                            <el-tooltip content="Editar" placement="top" effect="light">
                                <el-button type="text" class="text-primary" @click="editSubNotDanger(data.item)">
                                    <i class="fa fa-edit fa-lg"></i>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                placement="top" effect="light">
                                <el-button type="text" @click="changeStatus(data.item.id)"
                                    :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}` ">
                                    <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}` "></i>
                                </el-button>
                            </el-tooltip>
                        </div>
                    </template>
                </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%"
                            v-model="filterSubNotDangerSga.page"
                            :total="filterSubNotDangerSga.total"
                            :current-page="filterSubNotDangerSga.page"
                            :page-size="filterSubNotDangerSga.per_page"
                            @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination"
                            :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

        <!-- Modal for creating/editing subNotDanger -->
        <b-modal id="modal_create_subnotdanger" size="lg" hide-footer no-close-on-esc no-close-on-backdrop
            hide-header-close>
            <template #modal-title>
                {{ action === 'edit' ? 'Editar' : 'Registrar nueva' }} sustancia no peligrosa
            </template>
            <formSubNotDanger />
        </b-modal>

    </div>
</template>
<script>

// Generales
import { mapActions, mapState, mapMutations } from 'vuex';

// Componentes
import formSubNotDanger from './FormSubNotDanger.vue';
import DragAndDropList from '../../../../../shared/components/DragAndDropList.vue';


export default {
    name: 'SubNotDanger',
    components: {
        formSubNotDanger,
        DragAndDropList
    },

    data() {
        return {
            fields: [
                { key: 'name', label: 'Nombre', sortable: true },
                { key: 'is_active', label: 'Estado', sortable: true },
                { key: 'languages', label: 'Idiomas' },
                { key: 'actions', label: 'Acciones', class: 'text-center' }
            ]
        };
    },

    computed: {
        ...mapState('sgaSubNotDanger', [
            'subNotDangerSga', 
            'action', 
            'filterSubNotDangerSga',
            'subNotDanger'
        ]),

        getItemsSubNotDanger() {
            return (this.subNotDangerSga && this.subNotDangerSga && typeof this.subNotDangerSga === 'object') ? this.subNotDangerSga : []
        }
    },

    async created() {
        await this.getSubNotDangerSga();
    },

    methods: {
        ...mapActions('sgaSubNotDanger', [
            'getSubNotDangerSga', 
            'changeStatusSubNotDangerSga', 
            'showSubNotDangerSga', 
            'asyncLanguagesSubNotDangerSga', 
            'updatePrioritiesSubNotDanger'
        ]),
        ...mapMutations('sgaSubNotDanger', [
            'setActionSubNotDangerSga', 
            'setDefaultFilterSubNotDanger', 
            'setSubNotDangerItemSga',
            'loadAfterChangePagePagination',
            'loadAfterChangeSizePagination'
        ]),

        createSubNotDanger() {
            this.setActionSubNotDangerSga('create');
            this.$bvModal.show('modal_create_subnotdanger');
        },

        async clearFilter() {
            this.setDefaultFilterSubNotDanger();
            await this.getSubNotDangerSga();
        },

        async changeStatus(id) {
            await this.changeStatusSubNotDangerSga(id);
            await this.getSubNotDangerSga();
        },

        async editSubNotDanger(subNotDanger) {
            this.setActionSubNotDangerSga('edit');
            await this.showSubNotDangerSga(subNotDanger.id);
            this.$bvModal.show('modal_create_subnotdanger');
        },

        async searchSubNotDanger() {
            await this.getSubNotDangerSga(true);
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getSubNotDangerSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getSubNotDangerSga();
        }
    },
};
</script>

<style scoped>
.list-group-item {
    border: 1px solid white;
    -webkit-box-shadow: 0 2px 17px -3px #ccc;
    box-shadow: none;
    margin-bottom: 4px;
    background-color: #fcfcfc;
    border-radius: 5px;
    color: black;
}

.list-group-item:hover {
    cursor: pointer;
    background-color: #f4f4f4;
    border: 1px solid #f8f8f8;
}

.list-group-item .active {
   border-left: 4px solid rgb(38, 130, 167) !important; 
}

.list-group-item .inactive {
    border-left: 4px solid rgb(195, 80, 80) !important; 
}

@media (min-width: 0px) and (max-width: 500px) {

    .list-group-item {
        padding: 5px;
        position: relative;
        margin-bottom: 26px;
    }

    .list-group-item button span i {
        font-size: 29px;
    }

    .list-group-item-header {
        display: block !important;
        width: 100%;
    }

    .list-group-item-header-items {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .list-group-item-header-items .badge-info {
        width: 100%;
        height: 35px;
        padding: 7px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    .list-group-item-header-items .badge-info p,
    .list-group-item-header-items .badge-info span,
    .list-group-item-header-items .badge-info h4 {
        padding: 0px; 
        margin: 0px;
        font-size: 12px;
    }

    .list-group-item-header-items-text {
        margin-top: 4px;
    }

    .list-group-item-body {
        display: flex !important;
        justify-content: center !important;
        width: 100%;
        position: absolute;
        bottom: -30px;
    }
}

</style>